module.exports = __webpack_public_path__ + "static/media/web_shared-ui@2x.bf9cfb01.png";